/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [image-box-small.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 04.02.20, 16:36
 */

import React, {useEffect, useRef, useState} from 'react';
import {bindTooltip} from "../../actions/tippy-config";
import {getImageServerSmallUrl, getUserAvatar} from "../../actions/environment";
import {BlockedSvg, UserBlockOverlaySvg} from "../navigation/icons/nav-icons";
import {cn} from "../util/text-utils";

export const ImageBoxSmall = ({
                                  className, blocked, html, image, avatar,
                                  size = 'small',
                                  small = false,
                                  medium = false,
                                  bigger = false
                              }) => {
    const tooltipRef = useRef(null);
    const [tooltip, setTooltip] = useState(null);

    useEffect(() => {
        html && !tooltip && setTooltip(bindTooltip(tooltipRef, html, {
            placement: 'top',
            multiple: false,
            animation: 'shift-away'
        }));
        return () => {
            tooltip && tooltip.destroy();
        }
    }, []);

    const imageSize = size === 'bigger' ? 'image-box-bigger' :
        size === 'medium' ? 'image-box-medium' :
            size === 'small' ? 'image-box-small' : 'thumb';
    const imageClass = cn('rounded-start', [blocked, 'blocked-img'], imageSize);

    return <div className={cn('image-box-small-container', [className])} ref={tooltipRef}>
        <div className="rectangular-cover">
            <img className={imageClass}
                 src={image ? getImageServerSmallUrl(image) : avatar}/>
        </div>

        {blocked && <span className="blocked-thumb"><BlockedSvg/></span>}
    </div>
};

// user must contain avatar, firstname and lastname fields
export const UserBoxTable = ({user, blocked}) => {
    return <div className='position-relative'>
        <img className='image-box-small-round' src={getUserAvatar(user)}/>
        {blocked && <span className="image-box-small-round-overlay">
            <UserBlockOverlaySvg/>
        </span>}
    </div>
}